import { cn } from "@/services/hooks/utils";
import { MenuNav } from "./MenuNav";

export const SidebarNav = () => {
    return (
        <nav
            className={cn(
                "hidden lg:flex",
                "sticky top-6 max-w-full flex-col space-x-0 space-y-1 rounded-lg border bg-white/85 p-3 shadow-sm backdrop-blur",
            )}
        >
            <MenuNav />
        </nav>
    );
};
